namespace Application.Models {
    'use strict';

    import IAlarm = Models.IAlarm;

    export interface IConsoleAlarm extends IAlarm {
        deviceTypeName?: string;
        flexEventId?: number;
        timestamp?: Date;
        appearances?: number;
        collapsed: IConsoleAlarm[];
        collapsable: boolean;
        collapseTo: number;
        canWrite?: boolean;
    }
}